import React from "react";
import { Leaf } from "lucide-react";

const SIGNATURE_LOGO =
  "https://customer-assets.emergentagent.com/job_across-generations/artifacts/xxwpow14_file_00000000708071f8a14ea4cd794bda2a.png";

/**
 * Reusable GentleGiTo signature mark.
 *
 *   variant="mark"  — tiny sage leaf icon, used at the *opening* of an essay
 *                     (centered, lots of whitespace, no wordmark)
 *
 *   variant="full"  — full GentleGiTo leaf-and-wordmark signature image, used
 *                     as the *closing* mark of every essay (small/medium,
 *                     centered, generous whitespace)
 *
 * One source of truth — change here and every post inherits the new look.
 */
export default function LeafSignature({ variant = "full", className = "" }) {
  if (variant === "mark") {
    return (
      <div
        data-testid="leaf-mark"
        role="presentation"
        className={`flex justify-center py-10 sm:py-14 ${className}`}
      >
        <Leaf
          size={22}
          strokeWidth={1.25}
          className="text-primary/80 leaf-sway"
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <div
      data-testid="leaf-signature"
      role="presentation"
      className={`flex justify-center py-20 sm:py-28 ${className}`}
    >
      <img
        src={SIGNATURE_LOGO}
        alt="GentleGiTo"
        loading="lazy"
        className="w-32 sm:w-40 lg:w-48 h-auto opacity-90 select-none pointer-events-none"
      />
    </div>
  );
}
